document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-chat-widget]').forEach((widget) => {
    const openButton = widget.querySelector('[data-chat-open]');
    const closeButton = widget.querySelector('[data-chat-close]');
    const drawer = widget.querySelector('[data-chat-drawer]');
    const backdrop = widget.querySelector('[data-chat-backdrop]');
    if (!openButton || !closeButton || !drawer || !backdrop) return;

    const open = () => {
      drawer.hidden = false;
      backdrop.hidden = false;
      openButton.setAttribute('aria-expanded', 'true');
      document.body.classList.add('chat-is-open');
      closeButton.focus();
    };
    const close = () => {
      drawer.hidden = true;
      backdrop.hidden = true;
      openButton.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('chat-is-open');
      openButton.focus();
    };

    openButton.addEventListener('click', open);
    closeButton.addEventListener('click', close);
    backdrop.addEventListener('click', close);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !drawer.hidden) close();
    });
  });
});
